
import { PositionNode } from './position/PositionNode';
import { TechniqueNode } from './technique/TechniqueNode';
import { ConditionalNode } from './conditional/ConditionalNode';

export const nodeTypes = {
  positionNode: PositionNode,
  techniqueNode: TechniqueNode,
  conditionalNode: ConditionalNode,
};
